import { Empty } from 'antd';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../../store/rootReducer';
import { commaSeperator } from '../../../../../utils/validation';

const RepaymentMobileView: React.FC = () => {
    const data = useSelector((state: RootState) => state.investments.cashflow);

    const currency = useMemo(() => {
        const list = data && data[0];
        return (
            list?.netPayment?.currency ||
            list?.managementFee?.currency ||
            list?.interestPayment?.currency ||
            list?.principalOutstanding?.currency ||
            list?.principalRepayment?.currency ||
            list?.totalAmount?.currency
        );
    }, [data]);
    return (
        <div>
            {data?.map((cashflow, index) => (
                <div
                    className="px-4 py-2 mb-4 w-full"
                    style={{ backgroundColor: '#F5F6FF' }}
                    key={`${cashflow?.paymentDate?.date}_${index}`}
                >
                    <p className="font-bold text-sm p-1">{cashflow?.paymentDate?.date}</p>
                    <div className="flex flex-wrap">
                        <div className="w-1/2 p-1 pt-4">
                            <p className="font-bold text-xs" style={{ color: '#182D4F' }}>
                                Principal Outstanding
                            </p>
                            <p className="text-xs font-normal text-color-404040">
                                {cashflow?.principalOutstanding?.amountUpto2dp
                                    ? `${cashflow.principalOutstanding.currency} ${commaSeperator(
                                          parseFloat(String(cashflow.principalOutstanding.amountUpto2dp || 0)).toFixed(
                                              2,
                                          ),
                                      )}`
                                    : currency
                                    ? `${currency} 0.00`
                                    : ''}
                            </p>
                        </div>

                        <div className="w-1/2 p-1 pt-4">
                            <p className="font-bold text-xs" style={{ color: '#182D4F' }}>
                                Interest Payment
                            </p>
                            <p className="text-xs font-normal text-color-404040">
                                {cashflow?.interestPayment?.amountUpto2dp
                                    ? `${cashflow.interestPayment.currency} ${commaSeperator(
                                          parseFloat(String(cashflow.interestPayment.amountUpto2dp || 0)).toFixed(2),
                                      )}`
                                    : currency
                                    ? `${currency} 0.00`
                                    : ''}
                            </p>
                        </div>
                        <div className="w-1/2 p-1 pt-4">
                            <p className="font-bold text-xs" style={{ color: '#182D4F' }}>
                                Principal Repayment
                            </p>
                            <p className="text-xs font-normal text-color-404040">
                                {cashflow?.principalRepayment?.amountUpto2dp
                                    ? `${cashflow.principalRepayment.currency} ${commaSeperator(
                                          parseFloat(String(cashflow.principalRepayment.amountUpto2dp || 0)).toFixed(2),
                                      )}`
                                    : currency
                                    ? `${currency} 0.00`
                                    : ''}
                            </p>
                        </div>
                        <div className="w-1/2 p-1 pt-4">
                            <p className="font-bold text-xs" style={{ color: '#182D4F' }}>
                                Total Payment
                            </p>
                            <p className="text-xs font-normal text-color-404040">
                                {cashflow?.totalAmount?.amountUpto2dp
                                    ? `${cashflow.totalAmount.currency} ${commaSeperator(
                                          parseFloat(String(cashflow.totalAmount.amountUpto2dp || 0)).toFixed(2),
                                      )}`
                                    : currency
                                    ? `${currency} 0.00`
                                    : ''}
                            </p>
                        </div>
                        <div className="w-1/2 p-1 pt-4">
                            <p className="font-bold text-xs" style={{ color: '#182D4F' }}>
                                Management Fees
                            </p>
                            <p className="text-xs font-normal text-color-404040">
                                {cashflow?.managementFee?.amountUpto2dp
                                    ? `${cashflow.managementFee.currency} ${commaSeperator(
                                          parseFloat(String(cashflow.managementFee.amountUpto2dp || 0)).toFixed(2),
                                      )}`
                                    : currency
                                    ? `${currency} 0.00`
                                    : ''}
                            </p>
                        </div>
                        <div className="w-1/2 p-1 pt-4">
                            <p className="font-bold text-xs" style={{ color: '#182D4F' }}>
                                Net Total Payment
                            </p>
                            <p className="text-xs font-normal text-color-404040">
                                {cashflow?.netPayment?.amountUpto2dp
                                    ? `${cashflow.netPayment.currency} ${commaSeperator(
                                          parseFloat(String(cashflow.netPayment.amountUpto2dp || 0)).toFixed(2),
                                      )}`
                                    : currency
                                    ? `${currency} 0.00`
                                    : ''}
                            </p>
                        </div>
                    </div>
                </div>
            ))}
            {data.length === 0 && (
                <div className="flex justify-center items-center">
                    <Empty description={`No Repayment Schedule Data`} image={Empty.PRESENTED_IMAGE_SIMPLE} />
                </div>
            )}
        </div>
    );
};

export default RepaymentMobileView;
